//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { format } from 'date-fns';
import { faPlay, faPause } from '@fortawesome/pro-solid-svg-icons';
import { albumArtUrl } from '@motionelements/product2025/src/helpers/productMap.js';

export default {
  name: 'PreviewAudio',
  components: {
    AudioPlayer: () => import('@motionelements/product2025/src/components/AudioPlayer.vue'),
  },
  props: {
    element: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      faPause,
      faPlay,
      //
      play: false,
      currentTime: '00:00',
    };
  },
  computed: {
    ...mapState({
      windowWidth: state => state.browser.window.width,
    }),
    ...mapGetters({
      duration: 'product/duration',
    }),
    formattedDuration() {
      return this.duration ? format(new Date(this.duration * 1000), 'mm:ss') : null;
    },
  },
  methods: {
    albumArtUrl,
    togglePlay() {
      this.play = !this.play;
    },
    handleTimeUpdate(currentTime) {
      // console.log(currentTime);
      this.currentTime = currentTime ? format(new Date(currentTime * 1000), 'mm:ss') : '00:00';
    },
  },
};
